// Formats a Date as a calendar `YYYY-MM-DD` string using its LOCAL components.
//
// The DatePicker hands onChange a Date at local midnight. Using
// `d.toISOString().slice(0, 10)` would convert to UTC first, so in any
// timezone east of UTC (e.g. Asia/Kolkata, UTC+5:30) local midnight maps to
// the previous calendar day — calculating commissions for the wrong period and
// shifting the settlements filter back a day (QA 8.9.4). Reading the local
// Y/M/D components keeps the date the user actually picked.
export function toLocalIsoDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
